// extracted by mini-css-extract-plugin
export default {"background":"ChatBox_background__jjzNf","background_mobile":"ChatBox_background_mobile__URwDV"};